export default "__VITE_ASSET__BWY5Cp7B__"